import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';
import { Checkbox, MenuItem } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  value?: string;
  children?: React.ReactNode;
  hidden?: boolean;
  disabled?: boolean;
  isActive?: boolean;

  onClick?: () => void;
}

const PaiMenuItem: React.FC<Props> = ({ isActive, hidden, onClick, ...restProps }) => {
  const { classes } = useStyles();

  return (
    <MenuItem {...restProps} className={classes.menuItem} disableRipple={true} style={{ display: hidden ? 'none' : undefined }} onClick={onClick}>
      {!_.isNil(isActive) ? (
        <Checkbox
          className={classes.checkbox}
          checked={isActive}
          icon={<CheckBoxOutlineBlankSharpIcon />}
          checkedIcon={<CheckBoxSharpIcon />}
        />
      ) : null}
      {restProps.children}
    </MenuItem>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuItem: {
    fontSize: theme.typography.pxToRem(15),
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: theme.palette.action.hover,
    },
  },
  checkbox: {
    padding: 0,
    marginRight: '16px',
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(20),
      color: theme.palette.primary.main,
    },
    '&.Mui-checked': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

export default PaiMenuItem;
